import React from 'react';
import { Icon } from '@iconify/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';
import reactjsIcon from '@iconify/icons-logos/react';
import { HighlightedTextIcon } from 'components/molecules';

const Text = () => (
    <>
        私は約2年間、
        <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactjsIcon} />}
        >
            ReactJS
        </HighlightedTextIcon>{' '}
        と{' '}
        <HighlightedTextIcon className="mx-2" icon={<Icon icon={tailwindcssIcon} />}>
            TailwindCSS
        </HighlightedTextIcon>{' '}
        を使用した<span className="font-bold text-gray-800">Webサイト開発</span>のスキル向上に費やしてきました。今ではこれらのツールを使用してアプリを構築することにかなり自信を持っています：
    </>
);

const skills = {
    text: <Text />,
};

export default skills;
